<template>
  <div class="popout001">
    <h2>{{defaultData.title}}</h2>
    <button @click="confirmFn">{{defaultData.confirmText}}</button>
    <button @click="cancelFn">{{defaultData.cancelText}}</button>
  </div>
</template>

<script>
  export default {
    name: "",
    props: ["popData"],
    data() {
      return {
        defaultData: {
          title: "是否解除微信绑定？",
          confirmText: "确认",
          cancelText: "取消",
        }
      }
    },
    components: {},
    created() {
      this.defaultData = this.popData;
    },
    mounted() {

    },
    methods: {
      confirmFn() {
        this.$emit("confirmFn")
      },
      cancelFn() {
        this.$emit("cancelFn")
      },
    },
    computed: {},
  }
</script>

<style scoped lang="scss">
  .popout001 {
    width: 500px;
    height: 250px;
    background: #fff;
    box-shadow: 1px 1px 5px #000;
    position: absolute;
    top: 30%;
    left: 17%;
    h2 {
      font-size: 30px;
      margin-top: 60px;
    }
    button {
      width: 120px;
      height: 50px;
      background: #eb5657;
      color: #fff;
      margin-top: 50px;
      border-radius: 5px;
    }
    button:nth-of-type(2) {
      margin-left: 40px;
      background: #fff;
      color: #eb5657;
      border: 1px solid #eb5657;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/popout.vue